module.exports = __webpack_public_path__ + "img/ebook-hyread.2a9569de.png";